import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { fetchMovies } from 'store/actions/movie';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Chip,
  Paper,
  Toolbar,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core';
import Paginator from 'utils/Paginator';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 650,
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: 20,
  },
}));

const MovieList = (props) => {
  const classes = useStyles();

  const [page, setPage] = useState(0);

  const [movies, total, search] = useSelector(state => [
    state.movie.collection,
    state.movie.total,
    state.movie.search,
  ])

  const on = useDispatch();

  useEffect(() => {
    on(fetchMovies());
  }, [on]);

  const handleChangePage = (movie, newPage) => {
    setPage(newPage);
    on(fetchMovies({ search, page: newPage + 1 }));
  };

  return (
    <Paper className={classes.root}>
      <Toolbar>
        <div className={classes.toolbar}>
          <Typography variant="h6">
            Filmes
          </Typography>
          <Button
            variant="outlined"
            onClick={() => on(push('/movies/new'))}
            style={{ marginLeft: 10 }}
          >
            Adicionar
          </Button>
        </div>
      </Toolbar>
      <List component="nav">
        {movies.map(movie => (
          <ListItem
            button
            onClick={() => on(push(`/movies/${movie.id}`))}
            key={movie.id}
          >
            <ListItemText
              primary={movie.title}
              secondary=""
            />
            <ListItemSecondaryAction>
              <Chip
                size="small"
                color="default"
                label={movie.clientName}
                style={{ marginRight: 12 }}
              />
              <Chip
                size="small"
                color={movie.isActive ? 'primary' : 'secondary'}
                label={movie.isActive ? 'Ativo' : 'Inativo'}
              />
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Paginator
        page={page}
        total={total}
        handleChangePage={handleChangePage}
      />
    </Paper>
  );
};

export default MovieList;
